import React from 'react';
import { connect } from 'react-redux';
import DefaultFeedback from '../../utils/feedback/defaultFeedback';

const mapStateToProps = (state) => {
	const { rightFeedbackProps } = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
	};
};

const McqOptions = ({
	rightFeedbackProps: {
		feedbackChoices,
		feedbackImageChoices,
		feedbackAudioChoices,
		userAnswer,
		score,
		correctAnswer,
		defaultFeedback,
	},
}) => {
	let Choicelist = '';
	if (!!feedbackChoices) {
		if (!!feedbackChoices && Object.keys(feedbackChoices).length > 0) {
			Choicelist = Object.keys(feedbackChoices).map(function (choice) {
				if (feedbackChoices[choice] === '') {
					return false;
				}
				let RightChoice = feedbackChoices[choice];
				if (
					feedbackImageChoices[choice] !== '' &&
					feedbackImageChoices[choice] !== 'None'
				) {
					RightChoice = <img src={feedbackImageChoices[choice]} alt="" />;
				}
				if (
					!!feedbackAudioChoices &&
					!!feedbackAudioChoices[choice] &&
					feedbackAudioChoices !== 'None'
				) {
					RightChoice = (
						<audio controls controlsList="nodownload">
							<source src={feedbackAudioChoices[choice]} alt="" />
						</audio>
					);
				}

				let feedbackClass = '';
				if (
					userAnswer.toLowerCase().trim() ===
						feedbackChoices[choice].toLowerCase().trim() &&
					score === 0
				) {
					feedbackClass = 'wrong-answer';
				} else if (
					userAnswer.toLowerCase().trim() ===
						feedbackChoices[choice].toLowerCase().trim() &&
					score === 1
				) {
					feedbackClass = 'correct-answer';
				} else if (
					correctAnswer.toLowerCase().trim() ===
						feedbackChoices[choice].toLowerCase().trim() &&
					score === 0
				) {
					feedbackClass = 'correct-answer';
				} else if (
					correctAnswer.toLowerCase().trim() ===
						feedbackChoices[choice].toLowerCase().trim() &&
					score === -1
				) {
					feedbackClass = 'radio-blue';
				}
				return (
					<span key={feedbackChoices[choice]}>
						<li className={feedbackClass}>{RightChoice}</li>
						{feedbackClass === 'correct-answer' && !!defaultFeedback && (
							<DefaultFeedback defaultFeedback={defaultFeedback} />
						)}
					</span>
				);
			});
		}
	}
	return <span>{Choicelist}</span>;
};

export default connect(mapStateToProps)(McqOptions);
